import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;

  inline-size: 214px;
  block-size: 28px;

  text-align: start;
`;

export const GoogleNewsButton = styled.button`
  display: flex;
  gap: 6px;
  align-items: center;

  padding-block: 6px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 500;
  font-size: 16px;

  border: none;
  border-radius: 4px;

  background: #f7f7f7;

  cursor: pointer;
`;

export const TextContent = styled.span`
  color: #333333;
  font-size: 12px;
  font-family: Roboto;
  line-height: normal;
  white-space: nowrap;
`;

export const ImageGoogle = styled.img`
  display: block;

  inline-size: 16px;
  block-size: 16px;
`;
